// extracted by mini-css-extract-plugin
module.exports = {"gradientButton":"style-module__gradientButton___1ueLW","gradientButtonSmall":"style-module__gradientButtonSmall___wrPpO"};